import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { clearOldCategoryJobsFromStorage } from '@/utils';
export const useClearOldCategoryJobs = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  useEffect(_temp, t0);
};
function _temp() {
  clearOldCategoryJobsFromStorage(5);
}